import React from "react"
import SideBar from "../common/layout/sidebar.component.jsx"
import GenericListing from "../common/listing/generic-listing/GenericListing"
import { ObjectType } from "../state/listing/generic-listing/index"

const OrderFormListing = () => {
    SideBar.activateMenu("pricelist")

    return (
        <GenericListing
            objectType={ObjectType.PRICE_LISTS}
        />
    )
}

export default OrderFormListing


// WEBPACK FOOTER //
// ./src/price-list/List.tsx